module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Double-Shot-at-Love.56843c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Double-Shot-at-Love.jpg
// module id = BAzb
// module chunks = 0